import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"Frame\" clip-path=\"url(#clip0_7293_86994)\"><path id=\"Vector\" d=\"M19 12H7V24H19V12Z\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M21.875 4.16699V8.85449H17.1875\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M4.96109 6.9263C6.66896 4.62005 9.4099 3.125 12.5 3.125C15.5319 3.125 18.2277 4.56424 19.9413 6.79677L21.875 8.85417\" stroke=\"white\" stroke-width=\"2.08333\" stroke-linejoin=\"round\"></path></g><defs><clipPath id=\"clip0_7293_86994\"><rect width=\"25\" height=\"25\" fill=\"white\" transform=\"matrix(-1 0 0 1 25 0)\"></rect></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }